import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectPaymentList = (state) => {
    return selectOwnState(state).paymentList
}



// WEBPACK FOOTER //
// ./src/modules/payment/state/upload/selector.js